import {
  GET_TAXES_KEY_TOKEN_ERROR,
  GET_TAXES_KEY_USER_ERROR,
  GET_TAXES_KEY_USER_SUCCESS
} from '../TaxesKeyAuth/TaxesKeyAuth.actions'
import {
  GET_UNIQUE_PASS_TOKEN_ERROR,
  GET_USER_INFO_ERROR,
  GET_USER_INFO_SUCCESS
} from '../UniquePassAuth/UniquePassAuth.actions'
import {
  CHECK_GUEST_BUSINESS,
  CHECK_GUEST_BUSINESS_ERROR,
  CHECK_GUEST_BUSINESS_SUCCESS,
  CHECK_GUEST_BUSINESS_EXIST,
  CLEAN_GUEST_BUSINESS_ERRORS_SUCCESS,
  CLEAN_GUEST_BUSINESS_SUCCESS,
  GET_GUEST_BUSINESS_OPTIONS,
  GET_GUEST_BUSINESS_OPTIONS_ERROR,
  GET_GUEST_BUSINESS_OPTIONS_SUCCESS,
  GET_GUEST_FULL_NAME,
  GET_GUEST_FULL_NAME_ERROR,
  GET_GUEST_FULL_NAME_SUCCESS,
  RECOVER_ADMIN,
  RECOVER_ADMIN_SUCCESS,
  RECOVER_ADMIN_ERROR,
  RESET_REGISTER_WIZARD_STATE,
  REGISTER_CODE_VALIDATION,
  REGISTER_CODE_VALIDATION_ERROR,
  REGISTER_CODE_VALIDATION_SUCCESS,
  SAVE_TEMPORARY_PERSONAL_INFORMATION,
  SAVE_TEMPORARY_AUTHORITY_INFORMATION,
  SET_FOREIGN_REGISTRATION,
  SET_REGISTER_TYPE,
  OPEN_CONFIRM_NEW_AFFIDAVIT_DIALOG,
  CLOSE_CONFIRM_NEW_AFFIDAVIT_DIALOG,
  OPEN_MODAL,
  CLOSE_MODAL,
  INITIATE_FLOW,
  INITIATE_FLOW_SUCCESS,
  INITIATE_FLOW_ERROR,
  REGISTER_ERROR,
  REGISTER_ERROR_SUCCESS,
  REGISTER_ERROR_FAILURE,
  REGISTER_FLOW,
  REGISTER_FLOW_SUCCESS,
  REGISTER_FLOW_ERROR,
  SEND_VALIDATION_EMAIL,
  SEND_VALIDATION_EMAIL_SUCCESS,
  SEND_VALIDATION_EMAIL_ERROR,
  UPDATE_REGISTER_WIZARD_WITH_BACKUP,
  CREATE_TEMPORARY_BUYER,
  CREATE_TEMPORARY_BUYER_SUCCESS,
  CREATE_TEMPORARY_BUYER_ERROR,
  GET_REPRESENTATIVE_AUTHORITY,
  GET_REPRESENTATIVE_AUTHORITY_SUCCESS,
  GET_REPRESENTATIVE_AUTHORITY_ERROR,
  GET_COLLABORATION_AGREEMENT_CHOICES,
  GET_COLLABORATION_AGREEMENT_CHOICES_SUCCESS,
  GET_COLLABORATION_AGREEMENT_CHOICES_ERROR,
  REGISTER_COLLABORATION_AGREEMENT_CHOICES,
  REGISTER_COLLABORATION_AGREEMENT_CHOICES_SUCCESS,
  REGISTER_COLLABORATION_AGREEMENT_CHOICES_ERROR,
  GET_REPRESENTATIVES,
  GET_REPRESENTATIVES_SUCCESS,
  GET_REPRESENTATIVES_ERROR,
  GET_SIGNER_INFO,
  GET_SIGNER_INFO_SUCCESS,
  GET_SIGNER_INFO_ERROR,
  SET_SIGNER_SUCCESS,
  SET_SIGNER_ERROR,
  SET_HAS_ERROR,
  SET_SIGNER_NAME_SUCCESS,
  SET_SIGNER_NAME_ERROR,
  GET_DIRECTOR,
  GET_DIRECTOR_SUCCESS,
  GET_DIRECTOR_ERROR,
  GET_SURROGANT,
  GET_SURROGANT_SUCCESS,
  GET_SURROGANT_ERROR,
  REGISTER_COLLABORATION_INFO,
  REGISTER_COLLABORATION_INFO_SUCCESS,
  REGISTER_COLLABORATION_INFO_ERROR,
  SEND_RECEIPT_EMAIL,
  SEND_RECEIPT_EMAIL_SUCCESS,
  SEND_RECEIPT_EMAIL_ERROR,
  REGISTER_BUYER,
  REGISTER_BUYER_SUCCESS,
  REGISTER_BUYER_ERROR,
  SAVE_TEMPORARY_LEGAL_REPRESENTATION,
  GET_DOWNLOAD_FILE_URL,
  GET_DOWNLOAD_FILE_URL_SUCCESS,
  GET_DOWNLOAD_FILE_URL_ERROR,
  DONWLOAD_PDF,
  DONWLOAD_PDF_SUCCESS,
  DONWLOAD_PDF_ERROR,
  SEND_PDF_EMAIL_SUCCESS,
  SEND_PDF_EMAIL,
  SEND_PDF_EMAIL_ERROR,
  SET_DOCUMENT_VALUE_SUCCESS,
  SET_DOCUMENT_VALUE_ERROR,
  DOWNLOAD_AGREEMENT_COLLABORATION_PDF,
  DOWNLOAD_AGREEMENT_COLLABORATION_PDF_SUCCESS,
  DOWNLOAD_AGREEMENT_COLLABORATION_PDF_ERROR
} from './RegisterWizard.actions'

const initialModalsState = {
  mustBeRegister: { open: false },
  volunteersInstitutions: { open: false },
  mandatoryInstitutions: { open: false },
  successAgreement: { open: false }
}

const registerWizardState = {
  affidavit: { loading: false },
  business: { loading: false },
  emailVerify: {
    code: '',
    codeIsValid: undefined,
    emailSent: false,
    errorSendingEmail: false
  },
  downloadFileUrl: null,
  documentValue: '',
  error: false,
  errors: {
    businessInformationError: null,
    businessSearchError: null,
    dniError: null,
    recoveryError: null,
    affidavitError: null
  },
  guest: {},
  inscriptionId: '',
  identityDoesNotMatch: false,
  isRecoveryAdmin: false,
  isValidDocument: false,
  isTaxesKey: false,
  loading: false,
  registerBuyerLoading: false,
  isSignOperation: false,
  signerUniquePass: {},
  confirmNewAffidavitDialogState: {
    draft: false,
    error: undefined,
    loading: false,
    open: false
  },
  modals: initialModalsState,
  flow: {
    loading: false,
    error: null,
    data: null
  },
  representativeAuthority: {},
  collaborationAgreement: {},
  signerIdentification: {
    loading: false,
    searching: false,
    error: undefined,
    errorMainService: undefined,
    representative: [],
    signer: {
      dni: '',
      fullName: '',
      name: '',
      lastName: '',
      lastNamePaternal: '',
      lastNameMaternal: '',
      gender: ''
    },
    hasError: false,
    disabled: false,
    identifierType: '',
    isCivilRegistry: true
  },
  organismTypes: [],
  finishInscription: {
    loading: false,
    error: null,
    success: false,
    data: null
  },
  registrationPDFUrl: null,
  pdfEmailState: {
    emailSent: false,
    sendingEmail: false,
    errorSendingEmail: null
  },
  surrogantsList: [],
  director: {},
  emailReceipt: {
    emailSent: false,
    errorSendingEmail: false,
    success: null
  },
  collaborationAgreementPdf: {
    loading: false,
    error: null
  }
}

/**
 * The register wizard's reducer.
 */
const registerWizardReducer = (state = registerWizardState, { payload, type }) => {
  switch (type) {
    case GET_GUEST_FULL_NAME: {
      return { ...state, error: false, loading: true }
    }
    case GET_GUEST_FULL_NAME_ERROR: {
      return {
        ...state,
        errors: { ...state.errors, dniError: payload.reason },
        loading: false,
        error: true,
        guest: { ...state.guest, dni: payload.dni }
      }
    }
    case GET_GUEST_FULL_NAME_SUCCESS: {
      return {
        ...state,
        loading: false,
        guest: {
          ...state.guest,
          dni: payload.dni,
          firstLastName: payload.firstLastName,
          gender: payload.gender,
          name: payload.name,
          secondLastName: payload.secondLastName
        }
      }
    }
    case SAVE_TEMPORARY_PERSONAL_INFORMATION: {
      return {
        ...state,
        guest: {
          ...state.guest,
          lastName: payload.lastName,
          gender: payload.gender,
          name: payload.name,
          phone: payload.phone,
          phoneCode: payload.phoneCode,
          position: payload.position
        }
      }
    }
    case SAVE_TEMPORARY_AUTHORITY_INFORMATION: {
      return {
        ...state,
        representativeAuthority: {
          lastName: payload.lastName,
          dni: payload.dni,
          name: payload.name,
          phone: payload.phone,
          phoneCode: payload.phoneCode,
          email: payload.email,
          position: payload.position,
          isUniquePass: payload.isUniquePass,
          files: payload.files
        }
      }
    }
    case SAVE_TEMPORARY_LEGAL_REPRESENTATION: {
      return {
        ...state,
        legalRepresentation: [...payload.files]
      }
    }
    case RESET_REGISTER_WIZARD_STATE: {
      return registerWizardState
    }

    case GET_USER_INFO_SUCCESS: {
      return {
        ...state,
        loading: false,
        guest: {
          ...state.guest,
          dni: payload.dni,
          name: payload.name,
          lastName: payload.lastName,
          phone: payload.phone,
          gender: payload.gender,
          isUniquePass: 1
        }
      }
    }
    case GET_USER_INFO_ERROR: {
      return {
        ...state,
        ...payload.backup,
        error: true,
        loading: false
      }
    }
    case UPDATE_REGISTER_WIZARD_WITH_BACKUP: {
      return {
        ...state,
        ...payload,
        flow: {
          ...state.flow,
          ...payload.flow
        }
      }
    }
    case REGISTER_CODE_VALIDATION: {
      return {
        ...state,
        error: false,
        loading: true,
        emailVerify: { ...state.emailVerify, codeIsValid: undefined }
      }
    }
    case REGISTER_CODE_VALIDATION_SUCCESS: {
      return {
        ...state,
        error: false,
        loading: false,
        emailVerify: { ...state.emailVerify, codeIsValid: true, code: payload.code }
      }
    }
    case REGISTER_CODE_VALIDATION_ERROR: {
      return {
        ...state,
        error: true,
        loading: false,
        emailVerify: { ...state.emailVerify, codeIsValid: false }
      }
    }

    case SET_REGISTER_TYPE: {
      return { ...state, registerType: payload }
    }
    case CHECK_GUEST_BUSINESS: {
      return {
        ...state,
        business: { ...registerWizardState.business, dni: payload.dni },
        errors: { businessSearchError: registerWizardState.errors.businessSearchError },
        loading: true
      }
    }
    case CHECK_GUEST_BUSINESS_ERROR: {
      return {
        ...state,
        errors: {
          businessSearchError: payload.reason,
          orgLegalName: payload.orgLegalName,
          idRequest: payload.idRequest
        },
        loading: false
      }
    }
    case CHECK_GUEST_BUSINESS_EXIST: {
      return {
        ...state,
        business: { ...state.business, ...payload }
      }
    }
    case CHECK_GUEST_BUSINESS_SUCCESS: {
      return {
        ...state,
        business: { ...state.business, ...payload },
        loading: false
      }
    }
    case CLEAN_GUEST_BUSINESS_ERRORS_SUCCESS: {
      return { ...state, errors: registerWizardState.errors }
    }
    case CREATE_TEMPORARY_BUYER:
      return {
        ...state,
        loading: true,
        error: null
      }
    case CREATE_TEMPORARY_BUYER_SUCCESS:
      return {
        ...state,
        loading: false,
        business: {
          ...state.business,
          ...payload
        },
        error: null
      }

    case CREATE_TEMPORARY_BUYER_ERROR:
      return {
        ...state,
        loading: false,
        error: payload.message
      }

    case GET_GUEST_BUSINESS_OPTIONS: {
      return {
        ...state,
        business: { ...state.business, loading: true }
      }
    }
    case GET_GUEST_BUSINESS_OPTIONS_ERROR: {
      return {
        ...state,
        business: { ...state.business, loading: false }
      }
    }
    case GET_GUEST_BUSINESS_OPTIONS_SUCCESS: {
      return {
        ...state,
        business: {
          ...state.business,
          address: payload.address,
          district: payload.district,
          loading: false,
          state: payload.state,
          type: payload.type
        }
      }
    }
    case CLEAN_GUEST_BUSINESS_SUCCESS: {
      return {
        ...state,
        business: registerWizardState.business,
        errors: { businessSearchError: registerWizardState.errors.businessSearchError }
      }
    }
    case GET_UNIQUE_PASS_TOKEN_ERROR:
    case GET_TAXES_KEY_TOKEN_ERROR:
    case GET_TAXES_KEY_USER_ERROR: {
      return {
        ...payload.backup,
        errors: { businessSearchError: payload.reason },
        flow: { ...payload.backup.flow }
      }
    }
    case GET_TAXES_KEY_USER_SUCCESS: {
      return {
        ...payload.backup,
        business: { ...payload.backup.business, loading: false, name: payload.name },
        flow: { ...payload.backup.flow }
      }
    }
    case SET_FOREIGN_REGISTRATION: {
      return {
        ...state,
        guest: {
          ...state.guest,
          isForeign: payload
        }
      }
    }
    case GET_REPRESENTATIVE_AUTHORITY: {
      return {
        ...state,
        representativeAuthority: {
          ...state.representativeAuthority,
          loading: true,
          error: null
        }
      }
    }
    case GET_REPRESENTATIVE_AUTHORITY_SUCCESS: {
      return {
        ...state,
        representativeAuthority: {
          ...state.representativeAuthority,
          loading: false,
          names: payload.names,
          fatherLastName: payload.fatherLastName,
          motherLastName: payload.motherLastName,
          error: null
        }
      }
    }
    case GET_REPRESENTATIVE_AUTHORITY_ERROR: {
      return {
        ...state,
        representativeAuthority: {
          ...state.representativeAuthority,
          loading: false,
          error: payload.reason
        }
      }
    }
    case RECOVER_ADMIN: {
      return {
        ...state,
        isRecoveryAdmin: true,
        loading: true
      }
    }
    case RECOVER_ADMIN_SUCCESS: {
      return {
        ...state,
        business: { ...state.business, loading: false },
        loading: false
      }
    }
    case RECOVER_ADMIN_ERROR: {
      return {
        ...state,
        loading: false,
        errors: { ...state.errors, recoveryError: payload.reason }
      }
    }
    case OPEN_CONFIRM_NEW_AFFIDAVIT_DIALOG: {
      return {
        ...state,
        confirmNewAffidavitDialogState: {
          draft: false,
          error: undefined,
          loading: false,
          open: true
        }
      }
    }
    case CLOSE_CONFIRM_NEW_AFFIDAVIT_DIALOG: {
      return {
        ...state,
        confirmNewAffidavitDialogState: {
          draft: false,
          error: undefined,
          loading: false,
          open: false
        }
      }
    }
    case OPEN_MODAL: {
      return {
        ...state,
        modals: {
          ...state.modals,
          [payload]: { open: true }
        }
      }
    }
    case CLOSE_MODAL: {
      return {
        ...state,
        modals: {
          ...state.modals,
          [payload]: { open: false }
        }
      }
    }
    case INITIATE_FLOW: {
      return {
        ...state,
        flow: {
          ...state.flow,
          loading: true,
          error: null
        }
      }
    }
    case INITIATE_FLOW_SUCCESS: {
      return {
        ...state,
        flow: {
          ...state.flow,
          loading: false,
          error: null,
          data: payload
        }
      }
    }
    case INITIATE_FLOW_ERROR: {
      return {
        ...state,
        flow: {
          ...state.flow,
          loading: false,
          error: payload.reason
        }
      }
    }

    case REGISTER_FLOW: {
      return {
        ...state,
        flow: {
          ...state.flow,
          loading: true,
          error: null
        }
      }
    }
    case REGISTER_FLOW_SUCCESS: {
      return {
        ...state,
        flow: {
          ...state.flow,
          loading: false,
          data: {
            ...payload
          }
        }
      }
    }
    case REGISTER_FLOW_ERROR: {
      return {
        ...state,
        flow: {
          ...state.flow,
          loading: false,
          error: payload.reason
        }
      }
    }

    case GET_DOWNLOAD_FILE_URL:
      return {
        ...state,
        loading: true,
        error: null
      }
    case GET_DOWNLOAD_FILE_URL_SUCCESS:
      return {
        ...state,
        downloadFileUrl: payload.fileUrl,
        loading: false
      }
    case GET_DOWNLOAD_FILE_URL_ERROR:
      return {
        ...state,
        error: payload.reason,
        loading: false
      }

    case SEND_VALIDATION_EMAIL: {
      return {
        ...state,
        error: false,
        loading: true,
        emailVerify: {
          ...state.emailVerify,
          emailSent: false,
          errorSendingEmail: undefined,
          sendingEmail: true
        }
      }
    }
    case SEND_VALIDATION_EMAIL_SUCCESS: {
      return {
        ...state,
        error: false,
        loading: false,
        guest: {
          ...state.guest,
          id: payload.id,
          email: payload.email
        },
        emailVerify: {
          ...state.emailVerify,
          code: payload.code,
          emailSent: true,
          errorSendingEmail: false,
          sendingEmail: false
        }
      }
    }
    case SEND_VALIDATION_EMAIL_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        emailVerify: {
          ...state.emailVerify,
          emailSent: false,
          errorSendingEmail: true,
          sendingEmail: false
        }
      }
    }
    case REGISTER_ERROR: {
      return {
        ...state,
        error: { loading: true, error: null, data: null }
      }
    }
    case REGISTER_ERROR_SUCCESS: {
      return {
        ...state,
        error: { loading: false, error: null, data: payload }
      }
    }
    case REGISTER_ERROR_FAILURE: {
      return {
        ...state,
        error: { loading: false, error: payload.reason, data: null }
      }
    }
    case GET_COLLABORATION_AGREEMENT_CHOICES: {
      return {
        ...state,
        collaborationAgreement: {
          ...state.collaborationAgreement,
          loading: true,
          error: null
        }
      }
    }
    case GET_COLLABORATION_AGREEMENT_CHOICES_SUCCESS: {
      return {
        ...state,
        collaborationAgreement: {
          ...state.collaborationAgreement,
          loading: false,
          error: null
        },
        organismTypes: payload.types
      }
    }
    case GET_COLLABORATION_AGREEMENT_CHOICES_ERROR: {
      return {
        ...state,
        collaborationAgreement: {
          ...state.collaborationAgreement,
          loading: false,
          error: payload.reason
        }
      }
    }
    case REGISTER_COLLABORATION_AGREEMENT_CHOICES: {
      return {
        ...state,
        collaborationAgreement: {
          ...state.collaborationAgreement,
          loading: true,
          error: null
        }
      }
    }
    case REGISTER_COLLABORATION_AGREEMENT_CHOICES_SUCCESS: {
      return {
        ...state,
        collaborationAgreement: {
          ...state.collaborationAgreement,
          mandatoryAgreement: payload.choices.mandatoryAgreement,
          agreementType: payload.choices.agreementType,
          loading: false
        }
      }
    }
    case REGISTER_COLLABORATION_AGREEMENT_CHOICES_ERROR: {
      return {
        ...state,
        collaborationAgreement: {
          ...state.collaborationAgreement,
          loading: false,
          error: payload.reason
        }
      }
    }
    case GET_REPRESENTATIVES: {
      return {
        ...state,
        signerIdentification: {
          ...state.signerIdentification,
          loading: true
        }
      }
    }
    case GET_REPRESENTATIVES_SUCCESS: {
      return {
        ...state,
        signerIdentification: {
          ...state.signerIdentification,
          loading: false,
          representative: payload.representative,
          disabled: payload.disabled || state.disabled,
          identifierType: payload.identifierType,
          isCivilRegistry: payload.isCivilRegistry
        }
      }
    }
    case GET_REPRESENTATIVES_ERROR: {
      return {
        ...state,
        signerIdentification: {
          ...state.signerIdentification,
          loading: false,
          error: { code: payload.code, message: payload.message, title: payload.title }
        }
      }
    }
    case GET_SIGNER_INFO: {
      return {
        ...state,
        signerIdentification: {
          ...state.signerIdentification,
          searching: true,
          error: undefined
        }
      }
    }
    case GET_SIGNER_INFO_SUCCESS: {
      return {
        ...state,
        signerIdentification: {
          ...state.signerIdentification,
          searching: false,
          error: undefined
        }
      }
    }
    case GET_SIGNER_INFO_ERROR: {
      return {
        ...state,
        signerIdentification: {
          ...state.signerIdentification,
          searching: false,
          error: payload.error,
          isCivilRegistry: false,
          signer: {
            dni: payload.dni,
            fullName: '',
            name: '',
            lastName: '',
            lastNamePaternal: '',
            lastNameMaternal: '',
            gender: ''
          }
        }
      }
    }
    case SET_SIGNER_SUCCESS: {
      return {
        ...state,
        signerIdentification: {
          ...state.signerIdentification,
          signer: payload.signer,
          identifierType: payload.identifierType,
          isCivilRegistry: payload.isCivilRegistry
        }
      }
    }
    case SET_SIGNER_ERROR: {
      return {
        ...state,
        signerIdentification: {
          ...state.signerIdentification,
          error: { code: payload.code, message: payload.message, title: payload.title }
        }
      }
    }
    case SET_SIGNER_NAME_SUCCESS: {
      return {
        ...state,
        signerIdentification: {
          ...state.signerIdentification,
          signer: {
            ...state.signerIdentification.signer,
            name: payload.signer.name,
            lastName: payload.signer.lastName
          },
          isCivilRegistry: false
        }
      }
    }
    case SET_HAS_ERROR: {
      return {
        ...state,
        signerIdentification: {
          ...state.signerIdentification,
          hasError: payload.hasError
        }
      }
    }
    case SET_SIGNER_NAME_ERROR: {
      return {
        ...state,
        signerIdentification: {
          ...state.signerIdentification,
          error: { code: payload.code, message: payload.message, title: payload.title }
        }
      }
    }
    case GET_DIRECTOR: {
      return {
        ...state,
        finishInscription: {
          ...state.finishInscription,
          loading: true,
          error: null
        }
      }
    }
    case GET_DIRECTOR_SUCCESS: {
      return {
        ...state,
        finishInscription: {
          ...state.finishInscription,
          loading: false,
          error: null
        },
        director: payload.types
      }
    }
    case GET_DIRECTOR_ERROR: {
      return {
        ...state,
        finishInscription: {
          ...state.finishInscription,
          loading: false,
          error: payload.reason
        }
      }
    }
    case GET_SURROGANT: {
      return {
        ...state,
        finishInscription: {
          ...state.finishInscription,
          loading: true,
          error: null
        }
      }
    }
    case GET_SURROGANT_SUCCESS: {
      return {
        ...state,
        finishInscription: {
          ...state.finishInscription,
          loading: false,
          error: null
        },
        surrogantsList: payload.types
      }
    }
    case GET_SURROGANT_ERROR: {
      return {
        ...state,
        finishInscription: {
          ...state.finishInscription,
          loading: false,
          error: payload.reason
        }
      }
    }
    case REGISTER_COLLABORATION_INFO: {
      return {
        ...state,
        finishInscription: {
          ...state.finishInscription,
          loading: true,
          error: null
        }
      }
    }
    case REGISTER_COLLABORATION_INFO_SUCCESS: {
      return {
        ...state,
        finishInscription: {
          ...state.finishInscription,
          loading: false
        }
      }
    }
    case REGISTER_COLLABORATION_INFO_ERROR: {
      return {
        ...state,
        finishInscription: {
          ...state.finishInscription,
          loading: false,
          error: payload.reason
        }
      }
    }
    case SEND_RECEIPT_EMAIL: {
      return {
        ...state,
        error: false,
        loading: true,
        emailReceipt: {
          ...state.emailReceipt,
          emailSent: false,
          errorSendingEmail: undefined,
          sendingEmail: true
        }
      }
    }
    case SEND_RECEIPT_EMAIL_SUCCESS: {
      return {
        ...state,
        error: false,
        loading: false,
        guest: {
          ...state.guest,
          id: payload.id,
          email: payload.email
        },
        emailReceipt: {
          ...state.emailReceipt,
          code: payload.code,
          emailSent: true,
          errorSendingEmail: false,
          sendingEmail: false,
          success: { code: payload.code, message: payload.message }
        }
      }
    }
    case SEND_RECEIPT_EMAIL_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        emailReceipt: {
          ...state.emailReceipt,
          emailSent: false,
          errorSendingEmail: true,
          sendingEmail: false
        }
      }
    }
    case REGISTER_BUYER:
      return {
        ...state,
        registerBuyerLoading: true,
        error: null
      }
    case REGISTER_BUYER_SUCCESS:
      return {
        ...state,
        registerBuyerLoading: false,
        success: true,
        inscriptionId: payload.payload.numeroSolicitud
      }
    case REGISTER_BUYER_ERROR:
      return {
        ...state,
        registerBuyerLoading: false,
        success: false,
        error: payload.reason
      }
    case DONWLOAD_PDF:
      return {
        ...state,
        loading: true,
        error: null
      }
    case DONWLOAD_PDF_SUCCESS:
      return {
        ...state,
        loading: false,
        registrationPDFUrl: payload
      }
    case DONWLOAD_PDF_ERROR:
      return {
        ...state,
        loading: false,
        error: payload.reason
      }
    case SEND_PDF_EMAIL: {
      return {
        ...state,
        pdfEmailState: {
          ...state.pdfEmailState,
          sendingEmail: true,
          emailSent: false,
          errorSendingEmail: null
        }
      }
    }
    case SEND_PDF_EMAIL_SUCCESS: {
      return {
        ...state,
        pdfEmailState: {
          ...state.pdfEmailState,
          sendingEmail: false,
          emailSent: true,
          errorSendingEmail: null
        }
      }
    }
    case SEND_PDF_EMAIL_ERROR: {
      return {
        ...state,
        pdfEmailState: {
          ...state.pdfEmailState,
          sendingEmail: false,
          emailSent: false,
          errorSendingEmail: payload.reason
        }
      }
    }

    case SET_DOCUMENT_VALUE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        documentValue: payload.documentValue
      }
    case SET_DOCUMENT_VALUE_ERROR:
      return { ...state, error: true, loading: false }
    case DOWNLOAD_AGREEMENT_COLLABORATION_PDF:
      return {
        ...state,
        collaborationAgreementPdf: {
          loading: true,
          error: null
        }
      }
    case DOWNLOAD_AGREEMENT_COLLABORATION_PDF_SUCCESS:
      return {
        ...state,
        collaborationAgreementPdf: {
          loading: false,
          error: null
        }
      }
    case DOWNLOAD_AGREEMENT_COLLABORATION_PDF_ERROR:
      return {
        ...state,
        collaborationAgreementPdf: {
          loading: false,
          error: payload.reason
        }
      }
    default: {
      return state
    }
  }
}

export default registerWizardReducer
